// removed by extract-text-webpack-plugin
module.exports = {"instreamlink":"inStream__instreamlink__1_jyV","imageContainer":"inStream__imageContainer__3CMz3","compareImg":"inStream__compareImg__1zgF1","instreamPage":"inStream__instreamPage__RtiIU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/inStream/inStream.css
// module id = 574
// module chunks = 0